import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import cs from './locales/cs.json'
import en from './locales/en.json'
import de from './locales/de.json'
import pl from './locales/pl.json'
import sk from './locales/sk.json'
import it from './locales/it.json'
import hu from './locales/hu.json'
import uk from './locales/uk.json'
import es from './locales/es.json'
import fr from './locales/fr.json'
import nl from './locales/nl.json'
import ja from './locales/ja.json'

export const LANGUAGES = [
  { code: 'cs', name: 'Čeština', flag: '🇨🇿' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'sk', name: 'Slovenčina', flag: '🇸🇰' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
] as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: { translation: cs },
      en: { translation: en },
      de: { translation: de },
      pl: { translation: pl },
      sk: { translation: sk },
      it: { translation: it },
      hu: { translation: hu },
      uk: { translation: uk },
      es: { translation: es },
      fr: { translation: fr },
      nl: { translation: nl },
      ja: { translation: ja },
    },
    fallbackLng: 'cs',
    interpolation: { escapeValue: false },
    detection: {
      // querystring (?lng=sk) má přednost — onboarding/jiná appka může předat jazyk;
      // pak localStorage (volba z přepínače), nakonec jazyk prohlížeče. Volba se uloží.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage'],
    },
  })

export default i18n
